/**
 *  考生模块
 */
import http from '../assets/js/http'
// 进入我的考试
export const toMyExam = (params) => { return http.request({ url: '/examinee/toMyExam', method: 'post', params: params }) }
// 考试列表
export const getExamList = (params) => { return http.request({ url: '/examinee/getExamList', method: 'get', params: params }) }
// 考试入口
export const examStart = (params) => { return http.request({ url: '/examinee/examStart', method: 'get', params: params }) }
// 进入考试时检查
export const examCheck = (params) => { return http.request({ url: '/examinee/examCheck', method: 'post', params: params }) }
// 考生考试内容
export const examDetail = (params) => { return http.request({ url: '/examinee/examDetail', method: 'post', params: params }) }
// 考生提交考试
export const examSave = (params) => { return http.request({ url: '/examinee/examSave', method: 'post', params: params }) }
// 考生考试成绩
export const examScore = (params) => { return http.request({ url: '/examinee/examScore', method: 'get', params: params }) }
// 考生考试成绩击败比
export const examBeatRatio = (params) => { return http.request({ url: '/examinee/examBeatRatio', method: 'get', params: params }) }
// 考生考试排名列表
export const examRankingList = (params) => { return http.request({ url: '/examinee/examRankingList', method: 'get', params: params }) }
// 考生查看考试记录
export const checkExam = (params) => { return http.request({ url: '/examinee/checkExam', method: 'post', params: params }) }
